import { Box, Text } from "@chakra-ui/react";
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload, label, props }) => {
  if (!active || !payload || !payload.length) return null;
  const value = payload[0].value;
  var parts = label.split(" - ");
  return (
    <div
      style={{
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        padding: "8px",
      }}
    >
      {parts.map((_p) => (
        <p key={_p}>
          <em>{_p}</em>
        </p>
      ))}
      <p>{props._pointsPrefix + value}</p>
    </div>
  );
};

function PriceAveragesComponent(props) {
  const [chartData, setchartData] = React.useState({});

  React.useEffect(() => {
    const _chartData = props.dataToReturn.map((item) => {
      const date = new Date(item.priceObj.date);
      const formattedDate = date.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
      return {
        label: item.interval.name.replace("%%formattedDate%%", formattedDate),
        weightedAvg: item.weightedAvg,
        rawDate: formattedDate,
        intervalName: item.interval.name,
      };
    });
    // console.log("chart data", _chartData);
    setchartData(_chartData);

    return () => {};
  }, []);

  return (
    <Box p={2}>
      <Box p={2}>
        <Text color={"gray.800"} fontSize={"xl"}>
          {props._title ?? "UNKN"}
        </Text>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            data={chartData}
            margin={{ top: 20, right: 30, bottom: 20, left: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} />
            <YAxis dataKey="weightedAvg" domain={["dataMin", "dataMax"]} />
            <Tooltip content={<CustomTooltip props={props} />} />
            <Line type="monotone" dataKey="weightedAvg" stroke="#8884d8" dot />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
}

export default PriceAveragesComponent;
